import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import { deacService, VacancyCancellationReasonsType } from '../../services/central-api/deac';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { StyleProp, TextStyle } from 'react-native';

interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    purpose: VacancyCancellationReasonsType;
    zIndex: number;
    labelFontSize?: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
}

export default function CancellationReasonsDropdown({ value, setValue, zIndex, purpose, labelFontSize, labelStyle, viewStyle }: Props) {
    const [selectableCancellationReason, setSelectableCancellationReason] = useState<{ label: string; value: number; }[]>([]);

    async function loadCancellationReasons() {
        try {
            const cancellationReasons = await deacService.getCancellationReasonsByPurpose(purpose);
            setSelectableCancellationReason(cancellationReasons.map((cancellationReason) => {
                return {
                    value: cancellationReason.id,
                    label: cancellationReason.name,
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        loadCancellationReasons();
    }, [purpose]);

    return (
        <FilterDropdown
            label={translate('reason')}
            items={selectableCancellationReason}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelFontSize={labelFontSize}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}
